/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2557
 */

var r = require(/* 999 */"../999/index")
var i = require(/* 538 */"../../../../2466/2467/538")
module.exports = function (e) {
  return i(e) && "[object Set]" == r(e)
}
